import { config } from "../config";
import { getAuthToken } from "../util/auth";

export const getWorkspaceApi = async () => {
    const response = await fetch(`${config.url}/workspaces/workspace`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
    });

    if (!response.ok) {
        throw new Error('Fetching workspace faild');
    }

    const resData = await response.json();
    return resData;
}

export const inviteMemberApi = async (email) => {
    const response = await fetch(`${config.url}/workspaces/invite-member`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ email })
    });

    if (!response.ok) {
        throw new Error('Invite member faild');
    }

    const resData = await response.json();
    return resData;
}

export const deleteInvitationApi = async (invitationId) => {
    const response = await fetch(`${config.url}/workspaces/delete-invitation/${invitationId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        }
    });

    if (!response.ok) {
        throw new Error('Delete invitation faild');
    }

    const resData = await response.json();
    return resData;
}

export const getInvitationDetailsApi = async (token) => {
    const response = await fetch(`${config.url}/workspaces/invitation-details/${token}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });

    if (!response.ok) {
        throw new Error('Get invitation details faild');
    }

    const resData = await response.json();
    return resData;
}

export const acceptInvitationApi = async (token) => {
    const response = await fetch(`${config.url}/workspaces/accept-invitation/${token}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });

    if (!response.ok) {
        throw new Error('Accept invitation faild');
    }

    const resData = await response.json();
    return resData;
}

export const rejectInvitationApi = async (token) => {
    const response = await fetch(`${config.url}/workspaces/reject-invitation/${token}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });

    if (!response.ok) {
        throw new Error('Reject invitation faild');
    }

    const resData = await response.json();
    return resData;
}

export const addGroupApi = async (groupName) => {
    const response = await fetch(`${config.url}/workspaces/create-group`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ name: groupName })
    });

    if (!response.ok) {
        throw new Error('Create group faild');
    }

    const resData = await response.json();
    return resData;
}

export const saveGroupUsersApi = async (groupId, users) => {
    const response = await fetch(`${config.url}/workspaces/save-group-users`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ groupId, users })
    });

    if (!response.ok) {
        throw new Error('Save group users faild');
    }

    const resData = await response.json();
    return resData;
}

export const addMailboxApi = async (email) => {
    const response = await fetch(`${config.url}/workspaces/add-mailbox`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ email })
    });

    const resData = await response.json();

    if (!response.ok) {
        if (resData.message) {
            throw new Error(resData.message);
        } else if (resData.data && resData.data.length > 0) {
            throw new Error(resData.data.join(', '));
        } else {
            throw new Error('Add mailbox faild');
        }
    }

    return resData;
}

export const saveMailboxGroupsAndUsersApi = async (mailboxId, usersAndGroups) => {
    const response = await fetch(`${config.url}/workspaces/save-mailbox-users-and-groups`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ mailboxId, usersAndGroups })
    });

    if (!response.ok) {
        throw new Error('Save mailbox users and groups faild');
    }

    const resData = await response.json();
    return resData;
}